import { jsx } from "react/jsx-runtime";
import ApprovalIcon from "@mui/icons-material/Approval";
import { validateTidalLicense } from "../../base/index.js";
function Approval(props) {
  return /* @__PURE__ */ jsx(
    ApprovalIcon,
    {
      "data-testid": "Approval",
      ...props,
      "data-tidal": "TidalIcon",
      "data-tidal-icon": "Approval",
      "data-tidal-icon-meta": "miscellaneous"
    }
  );
}
Approval.tidalIconMeta = {
  categories: "miscellaneous",
  name: "Approval"
};
validateTidalLicense();
export {
  Approval
};
//# sourceMappingURL=Approval.js.map
